/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostReadNotificationResponse
 */
export interface PostReadNotificationResponse {
    /**
     * 
     * @type {number}
     * @memberof PostReadNotificationResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof PostReadNotificationResponse
     */
    message: string;
}

/**
 * Check if a given object implements the PostReadNotificationResponse interface.
 */
export function instanceOfPostReadNotificationResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function PostReadNotificationResponseFromJSON(json: any): PostReadNotificationResponse {
    return PostReadNotificationResponseFromJSONTyped(json, false);
}

export function PostReadNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostReadNotificationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function PostReadNotificationResponseToJSON(value?: PostReadNotificationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

